import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import { TextField } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

interface InviteDialogProps {
    open: boolean;
    handleClose: any;
    handleInviteUser: any;
    handleChangeRole: any;
    changeRoleEmail?: string;
    changeRoleRole?: string;
    setChangeRoleRole?: any;
    setChangeRoleEmail?: any;
}

const InviteDialog: React.FC<InviteDialogProps> = ({
    open,
    handleClose,
    handleInviteUser,
    handleChangeRole,
    changeRoleEmail,
    changeRoleRole,
    setChangeRoleRole,
    setChangeRoleEmail,
}) => {
    const [userEmail, setUserEmail] = useState<string>('');
    const [userRole, setUserRole] = useState<string>('');
    const [error, setError] = useState(false);
    const regex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    useEffect(() => {
        if (changeRoleEmail && changeRoleRole) {
            setUserEmail(changeRoleEmail);
            setUserRole(changeRoleRole);
        }
    }, [changeRoleEmail, changeRoleRole]);

    const handleEmailChange = (e) => {
        const value = e.target.value;
        const errorEmail = !regex.test(value);
        if (value && errorEmail) {
            setError(true);
        } else {
            setError(false);
        }
        setUserEmail(value);
    };

    const handleRoleChange = (e) => {
        const value = e.target.value;
        setUserRole(value);
    };

    const handleSubmit = (type: string) => {
        if (type === 'INVITE') {
            handleInviteUser(userEmail, userRole);
        } else {
            handleChangeRole(userEmail, userRole);
        }
        handleClose();
        setUserRole('');
        setUserEmail('');
        setChangeRoleEmail('');
        setChangeRoleRole('');
    };

    const handleCancel = () => {
        handleClose();
        setUserRole('');
        setUserEmail('');
        setChangeRoleEmail('');
        setChangeRoleRole('');
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
            keepMounted
            maxWidth={'sm'}
            fullWidth
        >
            <DialogTitle>
                {changeRoleEmail ? 'Update User Role' : 'Invite User'}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {changeRoleEmail
                        ? 'Update user role within this workspace'
                        : 'Invite users to collaborate within this workspace.'}
                </DialogContentText>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <TextField
                                autoFocus
                                margin="dense"
                                id="name"
                                label="Email Address"
                                type="email"
                                fullWidth
                                value={userEmail}
                                onChange={handleEmailChange}
                                disabled={!!changeRoleEmail}
                                error={error}
                                helperText={
                                    error
                                        ? 'Must be a valid email address'
                                        : null
                                }
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                                Role
                            </InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={userRole}
                                label="Role"
                                onChange={handleRoleChange}
                            >
                                <MenuItem value={'OWNER'}>Owner</MenuItem>
                                <MenuItem value={'ADMIN'}>Admin</MenuItem>
                                <MenuItem value={'USER'}>User</MenuItem>
                                <MenuItem value={'CONTRIBUTOR'}>
                                    Contributor
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel}>Cancel</Button>
                <Button
                    onClick={
                        changeRoleEmail
                            ? () => handleSubmit('CHANGE')
                            : () => handleSubmit('INVITE')
                    }
                    variant={'contained'}
                    disabled={error || !userEmail || !userRole}
                >
                    {changeRoleEmail ? 'Update Role' : 'Invite'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default InviteDialog;
